<template>
  <Doughnut :chart-data="chartdata"/>
</template>

<script>
import Doughnut from './Doughnut.vue'

export default {
  name: 'DoughnutContainer',
  components: { Doughnut },
  props: ['summary'],
  computed: {
    chartdata: function () {
      let labels = this.summary.map(a => a.category);
      let data = this.summary.map(a => a.total_amount);

      let charData = {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: ['#E2E062', '#B7D565', '#8FC76B', '#6CB873', '#4DA779', '#35957B', '#26837A', '#247175', '#295E6B', '#2E4C5D', '#303B4D', '#2D2B3B'],
        }]
      }
      return charData
    }
  }

}
</script>
